import { GET_DMX_CONTROLLERS, GET_DMX_CONTROLLERS_SUCCESS, GET_DMX_CONTROLLERS_ERROR } from './actionTypes';

const initialState = {
  errorGetDmxControllers: '',
  loadingGetDmxControllers: false,
  controllers: null,
};

const getControllers = (state = initialState, action) => {
  switch (action.type) {
    case GET_DMX_CONTROLLERS:
      state = { ...state, loadingGetDmxControllers: true };
      break;
    case GET_DMX_CONTROLLERS_SUCCESS:
      state = { ...state, loadingGetDmxControllers: false, controllers: action.payload.controllers };
      break;
    case GET_DMX_CONTROLLERS_ERROR:
      state = { ...state, errorGetDmxControllers: action.payload, loadingGetDmxControllers: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getControllers;
